export async function sendResearchSubscriptionEmail({
  email,
  searchField,
  contractType,
  educationRequirement,
  experienceRequirement,
  jobType,
  tools,
  aroundLatLng,
  aroundRadius,
  explain,
  searchOn,
  strapiUrl,
}: {
  email: string
  searchField?: string | null
  contractType?: string[] | null
  educationRequirement?: string[] | null
  experienceRequirement?: string[] | null
  jobType?: string[] | null
  tools?: string[] | null
  aroundLatLng?: string | null
  aroundRadius?: number | null
  explain?: string
  searchOn: 'firms' | 'offers'
  strapiUrl: string
}) {
  if (!strapiUrl) {
    throw new Error('strapiUrl is not defined')
  }

  const myHeaders = new Headers()
  myHeaders.append('Content-Type', 'application/json')
  myHeaders.append(
    'Authorization',
    `Bearer ${process.env.CORE_STRAPI_READ_TOKEN}`,
  )

  const rows = JSON.stringify({
    email,
    searchField: searchField || null,
    contractType: contractType || null,
    educationRequirement: educationRequirement || null,
    experienceRequirement: experienceRequirement || null,
    jobType: jobType || null,
    tools: tools || null,
    aroundLatLng: aroundLatLng || null,
    aroundRadius: aroundRadius || null,
    explain: explain || null,
    searchOn,
  })
  const response = await fetch(
    `${strapiUrl}/api/accounting-search-subscription`,
    {
      method: 'post',
      body: rows,
      headers: myHeaders,
    },
  )

  return response.json()
}

export async function getSubscription({
  uuid,
  domain,
  token,
}: {
  uuid: string
  domain: string
  token: string
}) {
  const response = await fetch(
    `${domain}/api/accounting-search-subscription/${uuid}`,
    {
      method: 'GET',
      headers: {
        Authorization: ` Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    },
  )

  if (response.status !== 200) {
    return null
  }

  const data = await response.json()

  return data || null
}

export async function unsubscribeSubscription({
  uuid,
  domain,
  token,
}: {
  uuid: string
  domain: string
  token: string
}) {
  const response = await fetch(
    `${domain}/api/accounting-search-subscription/unsubscribe/${uuid}`,
    {
      method: 'GET',
      headers: {
        Authorization: ` Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    },
  )

  if (response.status !== 200) {
    return null
  }

  const data = await response.json()

  return data?.message || null
}
